import { action, computed, observable } from 'mobx'
import { createViewModel } from 'mobx-utils'
import { JtechStore } from 'src/plugins/mobx'
export default class ServiceRequestModel {
    @observable serviceRequests = {};
    menuLoad = false;

    static getInstance () {
      return JtechStore.getSingleton('ServiceRequestModel', new ServiceRequestModel())
    }

    @action.bound setServiceRequest (protocol, serviceRequest, menu) {
      this.serviceRequests[protocol] = serviceRequest
      this.serviceRequests = { ...this.serviceRequests }
    }

    @action.bound removeServiceRequest (protocol) {
      delete this.serviceRequests[protocol]
      this.serviceRequests = { ...this.serviceRequests }
    }

    isLoadMenu () {
      return this.menuLoad
    }
}
